import { render, staticRenderFns } from "./ChipFechaHora.vue?vue&type=template&id=a0f0ac60"
import script from "./ChipFechaHora.vue?vue&type=script&lang=js"
export * from "./ChipFechaHora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports